<script>
export let backend;
let offers = [];

function csv() {
  let csvContent = "data:text/csv;charset=utf-8,Descriptor, Provider, Price\n" + offers
    .map(o => o.descriptor + ',' + o.provider + ',' + o.price)
    .join("\n");
  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "avg-wow-tbc-offers.csv");
  document.body.appendChild(link); // Required for FF
  link.click();
}

backend.getAvgOffersPerDescriptorWowTbc().then(wowAvgOffers => {
  offers = wowAvgOffers.offers;
});
</script>
<main>
<div class="container">
  <div class="row">
    <div class="col-sm">
      <button type="submit" class="btn btn-light mb-3" on:click|preventDefault={csv}>CSV</button>
    </div>
  </div>
</div>
<table class="table table-sm table-dark table-striped">
  <thead>
  <tr>
    <th scope="col">#</th>
    <th scope="col">Descriptor</th>
    <th scope="col">Provider</th>
    <th scope="col">Price</th>
    <th scope="col">Overgear Price</th>
    <th scope="col">Count</th>
  </tr>
  </thead>
  <tbody>
  {#each offers as offer, index}
  <tr>
    <th scope="row">{index}</th>
    <td>{offer.descriptor}</td>
    <td>{offer.provider}</td>
    <td>{offer.price}</td>
    <td class:table-success="{offer.ogsPrice != null && offer.price < offer.ogsPrice}"
        class:table-warning="{offer.ogsPrice != null && offer.price >= offer.ogsPrice}" 
    >
      {#if offer.ogsPrice != null}
      <div>
        <p class="d-inline">{offer.ogsPrice}</p>
        {#if offer.price < offer.ogsPrice}
        <p class="d-inline"> -{(100 - offer.price * 100 / offer.ogsPrice).toFixed(2)}%</p>
        {/if}
        {#if offer.price >= offer.ogsPrice}
        <p class="d-inline"> +{Math.abs(100 - offer.price * 100 / offer.ogsPrice).toFixed(2)}%</p>
        {/if}
      </div>
      {/if}
    </td>
    <td>{offer.count}</td>
  </tr>
  {/each}
  </tbody>
</table>
</main>

